import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import styles from "./CollaboratorSpace.local.scss";

import { TiWarningOutline } from "react-icons/ti";
import { UsersIcon, UserIcon, StatisticsIcon } from "../Common/Icons";

import CollaboratorApi from "../../services/CollaboratorServices";

class CollaboratorScore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      score: {
        collective: 0,
        individual: 0,
        collaboratorsCount: 23
      },
      error: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { date, period } = this.props;
    if (prevProps.date !== date || prevProps.period !== period) {
      this.handleUpdateCollaboratorScore();
    }
  }

  componentDidMount() {
    this.handleUpdateCollaboratorScore();
  }

  handleUpdateCollaboratorScore = () => {
    const { user, organization, period, date } = this.props;
    this.setState({ loading: true });
    CollaboratorApi.getCollaboratorScore(
      organization.id,
      user.adminisId,
      user.uid,
      period,
      date
    )
      .then(response => {
        this.setState({
          score: response,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error:
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors[0]
              ? error.response.data.errors[0]
              : "An error occurred",
          loading: false
        });
      });
  };

  getScoresFetching() {
    let valuationsFetching = [];
    valuationsFetching.push(
      <div key={0} className={styles.group_fetching}>
        <div className={styles.group_sub_1}>
          <div className={styles.gradiant} />
          <div className={styles.gradiant} />
        </div>
        <div className={classnames(styles.icone, styles.gradiant)} />
      </div>
    );
    for (let i = 0; i < 2; i++) {
      valuationsFetching.push(
        <div key={i + 1} className={styles.group_fetching}>
          <div className={styles.group_sub_1}>
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
          </div>
          <div className={styles.group_sub_2}>
            <div className={classnames(styles.icone, styles.gradiant)} />
            <div className={styles.gradiant} />
          </div>
        </div>
      );
    }
    return valuationsFetching;
  }

  renderScoresData(score) {
    return (
      <div>
        <div key="is" className={styles.group}>
          <div className={styles.group_sub_1}>
            <h5>{_("individualScore")}</h5>
            <h2>{score.individual}</h2>
          </div>
          <UserIcon size={28} />
        </div>
        <div key="cs" className={styles.group}>
          <div className={styles.group_sub_1}>
            <h5>{_("collectiveScore")}</h5>
            <h2>{score.collective}</h2>
          </div>
          <div className={styles.group_sub_2}>
            <UsersIcon size={24} />
            <span>
              {score.collaboratorsCount.collective}{" "}
              {score.collaboratorsCount.collective === 1
                ? _("collaborator")
                : _("collaborators")}
            </span>
          </div>
        </div>
        <div key="fs" className={styles.group}>
          <div className={styles.group_sub_1}>
            <h5>{_("organizationScore")}</h5>
            <h2>{score.organization}</h2>
          </div>
          <div className={styles.group_sub_2}>
            <StatisticsIcon size={24} />
            <span>
              {score.collaboratorsCount.organization}{" "}
              {score.collaboratorsCount.organization === 1
                ? _("collaborator")
                : _("collaborators")}
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    let { score, loading, error } = this.state;
    return (
      <div className={styles.upper_section}>
        {loading && (
          <div className={styles.fetching_scores}>
            {this.getScoresFetching()}
          </div>
        )}
        {error ? (
          <div className={styles.error_frame}>
            <TiWarningOutline />
          </div>
        ) : (
          !loading && this.renderScoresData(score)
        )}
      </div>
    );
  }
}

export default CollaboratorScore;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorScore.js